import React from 'react';
import { Button } from 'components/_new/Button';
import GoogleIcon from 'assets/icons/google-logo.svg';
import OfficeIcon from 'assets/icons/office-logo.svg';
import { useTranslation } from 'react-i18next';
import { useAuthIntegration } from './useAuthIntegration';

type LinkedAccountIntegratePropos = { programId?: number; sessionId?: number; membershipId?: number };

export const LinkedAccountIntegrate = (props: LinkedAccountIntegratePropos) => {
	const { t } = useTranslation();

	const { programId, membershipId, sessionId } = props;
	const { addGoogleAccountMutate, addGoogleAccountLoading, addMicrosoftAccountMutate, addMicrosoftAccountLoading } =
		useAuthIntegration({
			...(programId ? { programId } : {}),
			...(membershipId ? { membershipId } : {}),
			...(sessionId ? { sessionId } : {}),
		});

	return (
		<div className="flex flex-column gap-2">
			<div className="flex flex-row gap-2 w-full flex-wrap align-items-center justify-content-center">
				<Button
					label={t('linkedAccount.myAccount.addGoogleAccount')}
					onClick={() => addGoogleAccountMutate()}
					variant="primary-outlined"
					rounded
					loading={addGoogleAccountLoading}
					disabled={addGoogleAccountLoading || addMicrosoftAccountLoading}
					variantSize="sm"
				>
					<img src={GoogleIcon} alt="icon" />
					{t('linkedAccount.myAccount.addGoogleAccount')}
				</Button>
				<Button
					label={t('linkedAccount.myAccount.addMicrosoftAccount')}
					onClick={() => addMicrosoftAccountMutate()}
					variant="primary-outlined"
					rounded
					loading={addMicrosoftAccountLoading}
					disabled={addMicrosoftAccountLoading || addGoogleAccountLoading}
					variantSize="sm"
				>
					<img src={OfficeIcon} alt="icon" />
					{t('linkedAccount.myAccount.addMicrosoftAccount')}
				</Button>
			</div>
			<p className="text-muted">{t('linkedAccount.myAccount.integrateInfo')}</p>
		</div>
	);
};
